import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import moment from 'moment';

import { canonicalLink, metaDescription } from 'utils/seoUtils';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { localYearMonth, localMonth, localLongMonth } from 'utils/LocalDateTimeHelper';
import { loadCompetitionMatches } from '../reducers/competitionMatches';
import { loadCompetition } from '../reducers/competition';
import { load as loadCompetitions } from '../reducers/competitions';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import FootballLiveDatesList from '../components/FootballLiveDatesList';
import Tabs from 'modules/Common/components/Tabs';
import Dropdown from 'modules/Common/components/Dropdown';
import { toSlug } from 'utils';
import { getMonths } from 'modules/Football/utils';
import { getPropertyFromRoutes } from 'utils/routeUtils';
import { getTeamsNavList, getCompetitionsNavList } from 'modules/Football/utils';

import { MATCH_FILTER_EMPTY_MESSAGE, COMPETITIONS_REFRESH_INTERVAL_MILLIS } from 'modules/Football/consts';

require('./FootballFixturesResults.scss');

@layoutAsyncConnect(
  'FootballFixturesResults',
  [
    {
      dispatch: ({params: {compId, month}, routes}) => {
        const fixturesResults = getPropertyFromRoutes(routes, 'fixturesResults');

        return loadCompetitionMatches(compId, month, fixturesResults);
      },
      refreshInterval: COMPETITIONS_REFRESH_INTERVAL_MILLIS,
      state: state => ({matches: state.football.competitionMatches.matches })
    },
    {
      dispatch: () => loadCompetitions(),
      state: state => ({competitions: state.football.competitions.list })
    },
    {
      dispatch: ({params: {compId}}) => loadCompetition(compId),
      state: state => ({selectedCompetition: state.football.competition.selectedCompetition })
    },
    userServiceLayoutConnect()
  ]
)
@catchLifeCycleErrors
export default class FootballFixturesResults extends Component {
  static propTypes = {
    matches: PropTypes.object.isRequired,
    competitions: PropTypes.array.isRequired,
    params: PropTypes.object,
    routes: PropTypes.array.isRequired,
    fixturesResults: PropTypes.string.isRequired,
    selectedCompetition: PropTypes.object.isRequired
  }

  generateTabsBetweenMonths(competitionId, competitionName, competitionStart, competitionEnd, fixturesResults, monthStart, showingDefaultMonth) {

    let tabs = [];
    getMonths(competitionStart, competitionEnd, fixturesResults).map((date) => {

      const isIndex = showingDefaultMonth && date == localYearMonth(moment(monthStart));

      tabs.push({
          href: `/football/${fixturesResults}/competitions/${toSlug(competitionName)}/${competitionId}/${isIndex ? '' : date}`,
          text: localMonth(date),
          isIndex
      });
    });

    return tabs;
  }

  render() {
    const {
      matches: {
        from: monthStart,
        match: matchList = []
      },
      selectedCompetition: {
        name: selectedCompetitionName,
        competition_reference: {
          id: competitionId
        },
        season_start_date: seasonStartDate,
        season_end_date: seasonEndDate,
        show_teams_dropdown: showTeams = true,
        teams: competitionTeams
      },
      competitions = [],
      params = {},
      routes,
      fixturesResults
    } = this.props;

    let title, h1;

    if (fixturesResults == "results") {
      h1 = `Results`
    }
    else {
      h1 = `Fixtures`
    }

    title = `${h1} - ${localMonth(monthStart)}`

    const helmetProps = {
      title,
      ...canonicalLink(routes, params),
      ...metaDescription(`Latest ${fixturesResults} for ${selectedCompetitionName} in ${localLongMonth(monthStart)}`)
    };

    const tabs = this.generateTabsBetweenMonths(competitionId, selectedCompetitionName, seasonStartDate, seasonEndDate, fixturesResults, monthStart, !params.month);

    return (
      <div className="footballFixturesResults">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <header>
          <Dropdown title={selectedCompetitionName || 'COMPETITIONS'} shouldNavigate={true} options={getCompetitionsNavList(competitions, fixturesResults)} className="competitions-dropdown" noOptionsMessage="No competitions found"/>
          {showTeams && <Dropdown shouldNavigate={true} title='TEAMS' options={getTeamsNavList(competitionTeams, fixturesResults, selectedCompetitionName, competitionId)} className="teams-dropdown" noOptionsMessage="No teams found"/>}
          <h1>{h1}</h1>
        </header>
        <Tabs tabs={tabs} centerDefault/>
        { tabs.length > 0 ?
            <FootballLiveDatesList matchList={matchList} fixturesResults={fixturesResults} messageType="month"/>
          :
            <div className="football-live-filter-no-match-msg">
              <p>{MATCH_FILTER_EMPTY_MESSAGE['noTabs']}</p>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballCompetitionFixturesResults.js